let tinymcePromise;
let tinymceeditor
 export default function loadTinyMCE() {
   if (!tinymcePromise) {
     tinymcePromise = import('tinymce/tinymce').then((mod) => {
       // Import plugins and themes needed only once
       tinymceeditor = mod.default ?? mod;
       return Promise.all([
        import ('tinymce/models/dom/model'),
        import ('tinymce/themes/silver/theme'),
        import ('tinymce/icons/default/icons'),
        import ('tinymce/plugins/lists'),
        import ('tinymce/plugins/advlist'),
        import ('tinymce/plugins/table'),
        import ('tinymce/plugins/image'),
        import ('tinymce/plugins/pagebreak'),
        import ('tinymce/skins/ui/oxide/content.inline.js'),
        import ('tinymce/skins/ui/oxide/content.js'),
        import ('tinymce/skins/ui/oxide/skin.js'),
        import ('tinymce/skins/ui/oxide/skin.shadowdom.js'),
        import ('tinymce/skins/content/default/content.js')
       ]);
     });
   }
   return {tinymcePromise,tinymceeditor};
 }
